import { App, getServerSideProps } from 'map-viewer'

function ShareMap(props) {
  const { og, mapId, map, shareState } = props
  const { visualisation } = shareState

  const appProps = {
    og,
    mapId,
    map,
    shareState,
    visualisation
  }

  return (
    <App
      key={mapId}
      {...appProps}
    />
  )
}

export { getServerSideProps }
export default ShareMap
